<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const currentUrl = ref('');
const textToShare = ref('');

const props = defineProps<{
    attr?: Array<any>;
}>();

const tags = computed(() => {
    return props.attr?.[0] || [];
});

const getCurrentSubtitle = () => {
    const subtitle = computed(() => props.attr?.[1] || '');
    return subtitle.value.concat('.');
}

onMounted(() => {
    const baseUrl = window.location.origin;
    currentUrl.value = `${baseUrl}${route.path}`;
    textToShare.value = getCurrentSubtitle();
});

const copyLinkToClipboardFallback = (text) => {
    // Cria um elemento de texto temporário
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Estiliza o elemento para evitar interferência na página
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        // Tenta copiar o texto selecionado
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
        alert('Link Copiado!');
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
};

const copyLinkToClipboard = () => {
    if (navigator.clipboard && window.isSecureContext) {

        navigator.clipboard.writeText(currentUrl.value).then(() => {
            alert('Link Copiado!');
        }, (err) => {
            console.error('Error in copying text: ', err);
        });
    } else {

        copyLinkToClipboardFallback(currentUrl.value);
    }
};

const linkedInUrl = computed(() => `https://www.linkedin.com/shareArticle?url=${currentUrl.value}`);
const twitterUrl = computed(() => `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl.value)}&text=${encodeURIComponent(textToShare.value)}`);
const facebookUrl = computed(() => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl.value)}`);
</script>
<template>
    <div class="space-y-4">

        <!-- Social -->
        <div class="space-y-2">
            <p>
                Compartilhe
            </p>
            <div class="flex lg:space-x-4 share-icons">
                <button @click="copyLinkToClipboard" aria-label="Copy link">
                    <img class="w-8" src="/assets/icons/share.png" alt="Logo" />

                </button>
                <a :href="linkedInUrl" target="_blank" aria-label="Share on LinkedIn">
                    <img class="w-8 " src="/assets/icons/linkedin.png" alt="Logo" />

                </a>
                <a :href="twitterUrl" target="_blank" aria-label="Share on Twitter">
                    <img class="w-8 " src="/assets/icons/twitter.png" alt="Logo" />

                </a>
                <a :href="facebookUrl" target="_blank" aria-label="Share on Facebook">
                    <img class="w-8 " src="/assets/icons/facebook.png" alt="Logo" />

                </a>
            </div>
        </div>

        <!-- Tags -->
        <div class="flex flex-wrap">
            <div class="pr-1 pb-1" v-for="tag in tags" :key="tag">
                <div class="px-2 py-0.5 font-light text-color-primary rounded-md cursor-pointer bg-gray-200 hover:bg-gray-300">
                    <p class="text-xs md:text-sm text-start">
                        {{ tag }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

